import { isEqual } from "lodash";
import React, { useEffect } from "react";
import { DvirFormAreaDto } from "./types";

interface Props {
  formData: any;
  formTabs: Array<string> | undefined;
  setFormTabs: (tabs: Array<string>) => void;
}

export const FormTabsHandler = ({ formData, formTabs, setFormTabs }: Props) => {
  useEffect(() => {
    if (formData["areas"]) {
      const areas = formData["areas"] as Array<DvirFormAreaDto>;
      if (areas.length) {
        const newFormTabs = areas.filter((x) => !!x?.name).map((x) => x.name!);
        if (newFormTabs.length && !isEqual(formTabs, newFormTabs))
          setFormTabs(newFormTabs);
      } else if (!Array.isArray(formTabs) || formTabs.length) {
        setFormTabs([]);
      }
    }
  }, [formData, formTabs, setFormTabs]);

  return <></>;
};
